module.exports = __webpack_public_path__ + "img/1spade-01.bab2136a.svg";